import { CircleIcon, Divider, Flex, Label, Text } from '@shared/components';
import { UserTypeAvatar } from '@user-management/components';

import { USER_COLOR_STATUS, USER_STATUS_TEXT, type UserStatus } from '../../constants';

export interface UserInformationProps {
  firstName: string;
  lastName: string;
  email: string;
  appRoles: string[] | null;
  endAdornment?: React.ReactNode;
  status: UserStatus;
}

export default function UserInformation(props: Readonly<UserInformationProps>) {
  const { firstName, lastName, email, appRoles, status, endAdornment } = props;
  const fullName = `${firstName} ${lastName}`;

  const appRolesText = Array.isArray(appRoles) && appRoles.length > 0 ? appRoles.join(', ') : '-';

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <Flex
        sx={{
          p: (theme) => theme.spacing(3, 4),
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(3),
            alignItems: 'center',
          })}
        >
          <UserTypeAvatar fullName={fullName} email={email} />
          <Flex sx={{ flexDirection: 'column' }}>
            <Text variant='body1Semibold'>{fullName}</Text>
            <Text variant='body2' color='textSecondary'>
              {email}
            </Text>
          </Flex>
        </Flex>
        {endAdornment}
      </Flex>
      <Divider />
      <Flex
        sx={(theme) => ({
          p: theme.spacing(3, 4),
          gap: theme.spacing(4),
          alignItems: 'center',
        })}
      >
        <Flex sx={{ flex: 1, flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Text variant='caption' color='textSecondary'>
            บทบาทผู้ใช้
          </Text>
          <Text variant='body2'>{appRolesText}</Text>
        </Flex>
        <Divider orientation='vertical' flexItem />
        <Flex sx={{ flex: 1, flexDirection: 'column', gap: (theme) => theme.spacing(1) }}>
          <Text variant='caption' color='textSecondary'>
            สถานะผู้ใช้
          </Text>
          <Label
            startIcon={<CircleIcon sx={{ fontSize: '8px' }} />}
            color={USER_COLOR_STATUS[status]}
          >
            {USER_STATUS_TEXT[status]}
          </Label>
        </Flex>
      </Flex>
    </Flex>
  );
}
